import React, { Component } from 'react';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';
import FormattedPercentage from '../fields/number/FormattedPercentage';
import FormattedDate from '../fields/dates/FormattedDate';

import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('TRANSACTION_REPORT_REFUND', LOG_LEVELS.DEBUG);

class ReportRefund extends Component {

  render() {
    log.debug('render(): ', this.props);

    if (!this.props.src) {
      return(
        <div><LanguageStringResolver string='transactionBlank_noData'/></div>
      )
    }

    return(
      <div>
        {/*TODO Language Strings*/}
        {this.props.src.map((item, index) => (
          <div key={index}>
            <table className="mb20">
              <thead>
                <tr>
                  <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_item'/></th>
                  <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_value'/></th>
                  <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_item'/></th>
                  <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_value'/></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><LanguageStringResolver string='transactionInvoice_refundDocumentType'/></td>
                  <td>{item.refundDocumentType}</td>
                  <td><LanguageStringResolver string='transactionInvoice_supplierTaxNumber'/></td>
                  <td>{item.supplierTAXNumber}</td>
                </tr>
                <tr>
                  <td><LanguageStringResolver string='transactionInvoice_refundCountry'/></td>
                  <td>{item.refundCountry}</td>
                  <td><LanguageStringResolver string='transactionInvoice_supplierTaxNumberCountry'/></td>
                  <td>{item.supplierTAXNumberIssuedBy}</td>
                </tr>
                <tr>
                  <td><LanguageStringResolver string='transactionInvoice_refundingCountry'/></td>
                  <td>{item.refundingCountry}</td>
                  <td><LanguageStringResolver string='transactionInvoice_supplierInvoiceNumber'/></td>
                  <td>{item.supplierInvoiceNumber}</td>
                </tr>
                <tr>
                  <td><LanguageStringResolver string='transactionInvoice_supplierName'/></td>
                  <td>{item.supplierName}</td>
                  <td><LanguageStringResolver string='transactionInvoice_invoiceDate'/></td>
                  <td><FormattedDate value={item.invoiceDate}/></td>
                </tr>
                <tr>
                  <td><LanguageStringResolver string='transactionInvoice_supplierAddress'/></td>
                  <td>{item.supplierAddress}</td>
                  <td><LanguageStringResolver string='transactionInvoice_invoiceNumber'/></td>
                  <td>{item.invoiceNumber}</td>
                </tr>
                <tr>
                  <td><LanguageStringResolver string='transactionInvoice_supplierAddressNumber'/></td>
                  <td>{item.supplierAddressNr}</td>
                  <td><LanguageStringResolver string='transactionInvoice_currency'/></td>
                  <td>{item.currency}</td>
                </tr>
                <tr>
                  <td><LanguageStringResolver string='transactionInvoice_supplierAddressZIP'/></td>
                  <td>{item.supplierAddressZIP}</td>
                  <td><LanguageStringResolver string='transactionInvoice_documentDescription'/></td>
                  <td>{item.documentDescription}</td>
                </tr>
                <tr>
                  <td><LanguageStringResolver string='transactionInvoice_supplierAddressCity'/></td>
                  <td>{item.supplierAddressCity}</td>
                  <td><LanguageStringResolver string='transactionInvoice_documentFilename'/></td>
                  <td>{item.documentFilename}</td>
                </tr>
                <tr>
                  <td><LanguageStringResolver string='transactionInvoice_supplierCountry'/></td>
                  <td>{item.supplierCountry}</td>
                  <td><LanguageStringResolver string='transactionInvoice_totalTaxableBasis'/></td>
                  <td><span><FormattedCurrencyValue value={item.totalTaxableBasis}/></span></td>
                </tr>
                <tr>
                  <td><LanguageStringResolver string='transactionInvoice_supplierVATNumber'/></td>
                  <td>{item.supplierVATNr}</td>
                  <td><LanguageStringResolver string='transactionInvoice_totalVAT'/></td>
                  <td><span><FormattedCurrencyValue value={item.totalVATAmount}/></span></td>
                </tr>
                <tr>
                  <td><LanguageStringResolver string='transactionInvoice_supplierVATNumberCountry'/></td>
                  <td>{item.supplierVATNumberIssuedBy}</td>
                  <td><LanguageStringResolver string='transactionInvoice_totalDeductible'/></td>
                  <td><span><FormattedCurrencyValue value={item.totalDeductible}/></span></td>
                </tr>
              </tbody>
            </table>

            {/*Map of refund detail*/}

            {item.refundDetails.map((refundDetailsLine, index) =>
              {
                let detailLineNumber = index + 1;
                return (
                  <div>
                    <h3 className="mt0 mb5"><LanguageStringResolver string='transactionInvoice_refundDetailLine'/> {detailLineNumber}</h3>
                    <table className="mb20">
                      <thead>
                        <tr>
                          <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_item'/></th>
                          <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_value'/></th>
                          <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_item'/></th>
                          <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_value'/></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td><LanguageStringResolver string='transactionInvoice_refundingCountry'/></td>
                          <td>{refundDetailsLine.refundingCountry}</td>
                          <td><LanguageStringResolver string='transactionInvoice_VATCode'/></td>
                          <td>{refundDetailsLine.vatCode}</td>
                        </tr>
                        <tr>
                          <td><LanguageStringResolver string='transactionInvoice_taxableBasis'/></td>
                          <td><span><FormattedCurrencyValue value={refundDetailsLine.taxableBasis}/></span></td>
                          <td><LanguageStringResolver string='transactionInvoice_description'/></td>
                          <td>{refundDetailsLine.description}</td>
                        </tr>
                        <tr>
                          <td><LanguageStringResolver string='transactionInvoice_VAT'/></td>
                          <td><span><FormattedCurrencyValue value={refundDetailsLine.vat}/></span></td>
                          <td><LanguageStringResolver string='transactionInvoice_DescriptionLanguage'/></td>
                          <td>{refundDetailsLine.descriptionLanguage}</td>
                        </tr>
                        <tr>
                          <td><LanguageStringResolver string='transactionInvoice_VATAmount'/></td>
                          <td><span><FormattedCurrencyValue value={refundDetailsLine.vatAmount}/></span></td>
                          <td><LanguageStringResolver string='transactionInvoice_importDocumentNo'/></td>
                          <td>{refundDetailsLine.importDocumentNumber}</td>
                        </tr>
                        <tr>
                          <td><LanguageStringResolver string='transactionInvoice_VATDeductible'/></td>
                          <td><span><FormattedCurrencyValue value={refundDetailsLine.vatDeductible}/></span></td>
                          <td><LanguageStringResolver string='transactionInvoice_importReference'/></td>
                          <td>{refundDetailsLine.importReferenceInformation}</td>
                        </tr>
                        <tr>
                          <td><LanguageStringResolver string='transactionInvoice_deductionRate'/></td>
                          <td><span><FormattedPercentage value={refundDetailsLine.deductionRate}/></span></td>
                          <td><LanguageStringResolver string='transactionInvoice_attachedDocumentName'/></td>
                          <td>{refundDetailsLine.attachedDocumentName}</td>
                        </tr>
                        <tr>
                          <td><LanguageStringResolver string='transactionInvoice_proRata'/></td>
                          <td>{refundDetailsLine.proRata}</td>
                          <td><LanguageStringResolver string='transactionInvoice_attachedDocumentDescription'/></td>
                          <td>{refundDetailsLine.attachedDocumentDescription}</td>
                        </tr>
                        <tr>
                          <td><LanguageStringResolver string='transactionInvoice_natureOfItem'/></td>
                          <td>{refundDetailsLine.natureOfItem}</td>
                          <td><LanguageStringResolver string='transactionInvoice_fileCreationDate'/></td>
                          <td><span><FormattedDate value={refundDetailsLine.fileCreationDate}/></span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )
              }
            )}
          </div>
        ))}
      </div>
   );
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {};
}


function mapDispatchersToProps(dispatch) {
  return {}
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(ReportRefund);
